import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "./AuthContext";

type ProtectedRouteProps = {
  children: ReactNode;
  allowRoles: string[];
};

export const ProtectedRoute = ({
  allowRoles,
  children,
}: ProtectedRouteProps): JSX.Element => {
  const { token, role, isAuthenticated } = useAuth();
  
  // Check if user is authenticated (token exists in localStorage/context)
  if (!isAuthenticated || !token) {
    return (
      <Navigate
        to="/SignIn"
        replace
      />
    );
  }

  // Check if user has required role
  if (!role || !allowRoles.includes(role)) {
    return (
      <Navigate
        to="/unauthorized"
        replace
      />
    );
  }

  return children as JSX.Element;
};
